import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { webappUriPath } from '@utils/url';
import { FeedListViewSubText } from './shared';

const ReleaseInfoAccessibleLink = styled(AccessibleLink, {
  display: 'inline-flex',
});

export const ReleaseInfo = ({
  releaseTitle,
  releaseUri,
  artist,
  forceMobileView,
}: {
  releaseTitle: string;
  releaseUri: string;
  artist: {
    artistName: string;
    artistUri: string;
  } | null;
  forceMobileView?: boolean;
}) => {
  return (
    <>
      <ReleaseInfoAccessibleLink pathnameUri={webappUriPath(releaseUri)}>
        <FeedListViewSubText forceMobileView={forceMobileView} black className="release-title">
          {releaseTitle}&nbsp;
        </FeedListViewSubText>
      </ReleaseInfoAccessibleLink>
      {!!artist && (
        <>
          <FeedListViewSubText forceMobileView={forceMobileView} black>
            -&nbsp;
          </FeedListViewSubText>
          <ReleaseInfoAccessibleLink pathnameUri={webappUriPath(artist.artistUri)}>
            <FeedListViewSubText forceMobileView={forceMobileView} black className="artist-name">
              {artist.artistName}
            </FeedListViewSubText>
          </ReleaseInfoAccessibleLink>
        </>
      )}
    </>
  );
};
